/**
 * Option shape with label and value (e.g. DropdownOption).
 * Use these utilities to match a search string against options in selects, dropdowns, etc.
 */
export interface OptionWithLabelValue {
  label?: string
  value?: string
}

/** Normalize for matching: lowercase, trim, collapse spaces, hyphens as spaces. */
export function normalizeForMatch(s: string): string {
  return s.toLowerCase().trim().replace(/-/g, ' ').replace(/\s+/g, ' ')
}

/**
 * Find option matching search string (by label or value).
 * Uses flexible matching: exact match, includes, or inverse includes.
 * Returns undefined if no match.
 */
export function findMatchingOption<T extends OptionWithLabelValue>(searchString: string, options: T[]): T | undefined {
  if (!searchString || !options?.length) return undefined
  const normalized = normalizeForMatch(searchString)
  return options.find((opt) => {
    const labelNorm = normalizeForMatch(opt.label ?? '')
    const valueNorm = normalizeForMatch(opt.value ?? '')
    return (
      labelNorm === normalized ||
      valueNorm === normalized ||
      labelNorm.includes(normalized) ||
      valueNorm.includes(normalized) ||
      normalized.includes(labelNorm) ||
      normalized.includes(valueNorm)
    )
  })
}
